/**
 * Is this URL a developer-portal API call (as opposed to a customer one)?
 *
 * One definition, shared by `devJwtInterceptor` (which attaches the dev Bearer
 * token to these) and `httpErrorInterceptor` (which keeps the static `/error`
 * page for these only; customer calls report a 5xx through their own toast, e.g.
 * the `SRV` diagnostic code). Keep the prefixes here so the two cannot drift.
 */
const DEV_PORTAL_PATH_PREFIXES = ['/api/admin/dev/', '/api/admin/logs/'] as const;

export function isDevPortalPath(pathname: string): boolean {
  return DEV_PORTAL_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/** Same test on a raw request URL (absolute or relative). Unparseable URLs are not dev-portal calls. */
export function isDevPortalUrl(rawUrl: string): boolean {
  try {
    return isDevPortalPath(new URL(rawUrl, location.origin).pathname);
  } catch {
    return false;
  }
}
